export type SelectPropertyEventDetails =
  | {
      propertyId: number
      assigneeId: string
    }
  | null
  | 'Down'
  | 'Next'
  | 'Previous'
export type SelectPropertyEvent = CustomEvent<SelectPropertyEventDetails>
export const selectPropertyEventName = 'selectProperty'
